import { Component } from 'opus-angular-seed-core';
import template from './template.html';

/**
 * Learner visibility of the selected language. The texts are given only when they apply, the
 * editor decides about the state.
 */
@Component({
    bindings: {
        isSourceLanguage: '<',
        isApplicable: '<',
        isVisible: '<',
        canToggle: '<',
        liveText: '<',
        notConfirmedText: '<',
        untranslatedText: '<',
        reviewText: '<',
        isReady: '<',
        translateAllLabel: '<',
        isLoading: '<',
        onToggle: '&',
        onTranslateAll: '&'
    },
    template
})
export default class {
    /**
     * Getter and setter of the visibility switch: the switch only asks for the change, the
     * displayed state follows the stored visibility, so a cancelled or refused change is not shown.
     */
    visibility (isVisible) {
        if (isVisible !== undefined) {
            this.onToggle();
        }

        return this.isVisible;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/authoringTool/editor/languageVisibility/index.js